import { z } from "zod";
import { optionalEmailSchema, phoneSchema } from "./common.schema.ts";

export const createPersonalSchema = z.object({
  nom: z
    .string()
    .trim()
    .min(2, "Le nom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  postnom: z
    .string()
    .trim()
    .min(2, "Le postnom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  prenom: z
    .string()
    .trim()
    .min(2, "Le prénom est requis et doit avoir au minimum 2 caractères")
    .max(100, "Maximum 100 caractères"),

  genre: z
    .string()
    .trim()
    .min(1, "Le genre est requis ")
    .max(100, "Maximum 100 caractères"),
  lieu_naissance: z
    .string()
    .trim()
    .min(
      2,
      "Le lieu de naissance est requis et doit avoir au minimum 2 caractères",
    )
    .max(100, "Maximum 100 caractères"),
  date_naissance: z
    .string()
    .trim()
    .min(
      2,
      "La date de naissance est requise et doit avoir au minimum 2 caractères",
    )
    .max(100, "Maximum 100 caractères"),

  avenue: z
    .string()
    .trim()
    .min(2, "L'avenue est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  commune: z
    .string()
    .trim()
    .min(2, "La commune est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  quartier: z
    .string()
    .trim()
    .min(2, "Le quartier est requis et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),
  ville: z
    .string()
    .trim()
    .min(2, "La ville est requise et doit avoir au minimum 2 caractères")
    .max(250, "Maximum 250 caractères"),

  email: optionalEmailSchema,

  telephone: phoneSchema,

  grade_id: z.number({
    error: "Le grade est requis",
  }),
  fonction_id: z.number({
    error: "La fonction est requise",
  }),
  domaine_id: z.number({
    error: "Le domaine est requis",
  }),
});
